import { TwitterRequestTokenResponse } from 'api/auths-api/twitter-request-token';

export const mockTwitterRequestTokenResponse: TwitterRequestTokenResponse = {
  authenticateUrl: 'https://api.twitter.com/oauth/authenticate?oauth_token=xxx',
};
